<script>

    import { toast } from 'bulma-toast'
    import { modalStore } from '../stores'
       
    import ChargesService from '../$services/charges.service'
    
    import Providers from '../$components/providers.svelte'
    import DateRange from '../$components/date.range.svelte'
    import Button from '../$components/button.svelte'
    import ButtonSave from '../$components/button.save.svelte'
    import Switch from '../$components/switch.svelte'
    import Form from '../$components/form.svelte'

    let query = {}
    let loading = false
    let allServices = false
    let element

    async function downloadCharges() {

        if(allServices) {
            delete query.provider
            delete query.service
            delete query.shipmentCreatedStart
            delete query.shipmentCreatedEnd
        }
    
        loading = true
        const blob = await ChargesService.downloadCharges(query)
        loading = false
    
        if(!blob)
            return toast({message: 'Error al descargar el archivo', type: 'is-danger'})

        const fileName = `Cargos_${query.provider}_${query.service}`
        
        element.download = `${fileName}.xlsx`
        element.href = window.URL.createObjectURL(blob)
        element.click()
    }

</script>

<a bind:this={element} style="display: none;" href="/">.</a>

<Form on:submit={downloadCharges} { loading } >
    
    {#if !allServices}
        <div class="columns">
            <div class="column">
                <Providers bind:provider={query.provider} bind:service={query.service} />
                <DateRange bind:dateStart={query.shipmentCreatedStart} bind:dateEnd={query.shipmentCreatedEnd} />
            </div>
        </div>
    {/if}

    <Switch bind:checked={allServices} label="Todos los cargos" />

    <div class="is-flex is-justify-content-flex-end is-align-items-center">
        <Button on:click={modalStore.close} text="Cancelar" icon="ban" />
        <ButtonSave text="Descargar" icon="download" bind:loading />
    </div>
</Form>